import { render, staticRenderFns } from "./BtnExcluirSeguros.vue?vue&type=template&id=11da9868&"
import script from "./BtnExcluirSeguros.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirSeguros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports